import Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import Exporting from "highcharts/modules/exporting";
import ExportData from "highcharts/modules/export-data";
import HighchartsVue from "highcharts-vue";

export default defineNuxtPlugin(({ vueApp }) => {
  HighchartsMore(Highcharts);
  Exporting(Highcharts);
  ExportData(Highcharts);
  vueApp.use(HighchartsVue);
});
